import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BaseResponse } from '../models/auth.models';
import {
  PosTerminal,
  CreatePosRequest,
  UpdatePosRequest,
  RegenerateCodeResponse,
} from '../models/pos.models';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PosService extends ApiService {
  private readonly endPoint = environment.apiUrl + '/api/Pos';

  getPosByStore(storeId: string): Observable<BaseResponse<PosTerminal[]>> {
    return this.http.get<BaseResponse<PosTerminal[]>>(`${this.endPoint}?storeId=${storeId}`);
  }

  createPos(data: CreatePosRequest): Observable<BaseResponse<PosTerminal>> {
    return this.http.post<BaseResponse<PosTerminal>>(this.endPoint, data);
  }

  updatePos(id: string, data: UpdatePosRequest): Observable<BaseResponse<PosTerminal>> {
    return this.http.put<BaseResponse<PosTerminal>>(`${this.endPoint}/${id}`, data);
  }

  // eslint-disable-next-line
  deletePos(id: string): Observable<BaseResponse<any>> {
    // eslint-disable-next-line
    return this.http.delete<BaseResponse<any>>(`${this.endPoint}/${id}`);
  }

  regenerateCode(id: string): Observable<RegenerateCodeResponse> {
    return this.http.post<RegenerateCodeResponse>(`${this.endPoint}/${id}/regenerate`, {});
  }
}
